// extracted by mini-css-extract-plugin
export default {"ulstyle":"BigScreenNavbar_ulstyle__q6Me8","colored":"BigScreenNavbar_colored__y5USH","laptopViewNavbar":"BigScreenNavbar_laptopViewNavbar__Ad6wl"};